import(/* webpackMode: "eager" */ "/vercel/path0/src/app/referanslar/page.tsx");
